import { Form, Input, DatePicker, Select, Checkbox } from "antd";
import { AdvancedType } from "./types";
import { useEffect, useState } from "react";
import { BranchInfoType } from "../leadsManagement/types";
import fetchAdvisorsData from "../leadsManagement/utils/fetchAdvisorsData";
import { convertToBranchOptions } from "../leadsManagement/utils/convertToAdvisorTreeSelectOptions";
import dayjs from "dayjs";

interface AdvanceProps {
  advanceData: AdvancedType | undefined;
  setAdvanceData: any;
}

const PerformanceTab = ({ advanceData, setAdvanceData }: AdvanceProps) => {
  const [form] = Form.useForm();
  const [branchSelectOptions, setBranchSelectOptions] = useState<any>([]);
  const [advisors, setAdvisors] = useState<BranchInfoType[]>([]);

  useEffect(() => {
    if (advanceData) {
      form.setFieldsValue({
        hireDate: advanceData.hireDate ? dayjs(advanceData.hireDate) : null,
        terminationDate: advanceData.terminationDate
          ? dayjs(advanceData.terminationDate)
          : null,
        insuranceEndDate: advanceData.insuranceEndDate
          ? dayjs(advanceData.insuranceEndDate)
          : null,
        insuranceStartDate: advanceData.insuranceStartDate
          ? dayjs(advanceData.insuranceStartDate)
          : null,
        branchCode: advanceData.branchCode,
        excludeKeepCost: advanceData.excludeKeepCost,
        referrer: advanceData.referrer,
        hasSalesKit: advanceData.hasSalesKit,
      });
    }
  }, [form, advanceData]);

  const onChange = () => {
    const {
      hireDate,
      terminationDate,
      insuranceStartDate,
      insuranceEndDate,
      branchCode,
      excludeKeepCost,
      referrer,
      hasSalesKit,
    } = form.getFieldsValue();

    setAdvanceData({
      hireDate: hireDate
        ? dayjs(hireDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
        : "",
      terminationDate: terminationDate
        ? dayjs(terminationDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
        : "",
      insuranceStartDate: insuranceStartDate
        ? dayjs(insuranceStartDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
        : "",
      insuranceEndDate: insuranceEndDate
        ? dayjs(insuranceEndDate).format("YYYY-MM-DD") + "T00:00:00.000Z"
        : "",
      branchCode: branchCode,
      excludeKeepCost: excludeKeepCost,
      referrer: referrer,
      hasSalesKit: hasSalesKit,
    });
  };

  const header = {
    headers: {
      "x-api-key": process.env.REACT_APP_X_API_KEY,
    },
  };

  useEffect(() => {
    fetchAdvisorsData(header, setAdvisors);
  }, []);

  useEffect(() => {
    if (advisors.length > 0) {
      setBranchSelectOptions(convertToBranchOptions(advisors));
    }
  }, [advisors]);

  return (
    <div className="tab-container">
      <Form form={form} labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
        <Form.Item label="입사일 (AD계약일)" name="hireDate">
          <DatePicker
            className="w-2/3"
            placeholder="입사일을 선택해주세요."
            onChange={onChange}
          />
        </Form.Item>
        <Form.Item label="퇴사일" name="terminationDate">
          <DatePicker
            className="w-2/3"
            placeholder="퇴사자일 경우 퇴사일을 선택해주세요."
            onChange={onChange}
          />
        </Form.Item>
        <p className="reminder">
          퇴사일 입력 시 퇴사처리가 되어 해당 어드바이저는 퇴사자 목록에서
          확인가능합니다.
        </p>
        <Form.Item
          label="소속지사"
          name="branchCode"
          className="mt-5"
          rules={[
            { required: true, message: "소속지사 선택은 필수 항목입니다." },
          ]}
        >
          <Select
            options={branchSelectOptions}
            className="w-2/3"
            onChange={onChange}
          />
        </Form.Item>
        <Form.Item
          label="Keep비용"
          name="excludeKeepCost"
          valuePropName="checked"
        >
          <Checkbox onChange={onChange}>Keep비용 제외</Checkbox>
        </Form.Item>
        <Form.Item label="보험종료일" name="insuranceEndDate">
          <DatePicker
            className="w-2/3"
            placeholder="보험종료일을 선택해주세요."
            onChange={onChange}
          />
        </Form.Item>
        <Form.Item label="보험갱신여부" name="insuranceStartDate">
          <DatePicker
            className="w-2/3"
            placeholder="보험갱신여부를 선택해주세요."
            onChange={onChange}
          />
        </Form.Item>
        <Form.Item label="채용자" name="referrer">
          <Input
            className="w-2/3"
            placeholder="채용자를 선택해주세요."
            onChange={onChange}
          />
        </Form.Item>
        <Form.Item label="세일즈킷 보유여부" name="hasSalesKit">
          <Select
            options={[
              { label: "Y", value: true },
              { label: "N", value: false },
            ]}
            onChange={onChange}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default PerformanceTab;
